module.exports = __webpack_public_path__ + "media/img/frontend_application/logo-footer-6e00ef5781ac557d1e3793346d2a6a5a.png";